module.exports = __webpack_public_path__ + "static_portal/img/4.6c139d0a.jpg";